import { Component, OnInit } from '@angular/core';
import { AppEventService, LoginService, LoginState, RestDataService } from 'pumpcalc-core';
import { ListLoaderService } from './list-loader.service';
import { environment } from '../environments/environment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'pumpcalc-builder';
  loggedIn = false;
  cacheLoading = true;
  cacheLoadedAndNotSharing=false;
  menuItems = [{ label: "Select", event: { name: "OPEN_LIST", context: "Pumpset" } }, { label: "Save", event: { name: "SAVE", context: "Pumpset" } },{ label: "Share", event: { name: "SHARE", context: "Pumpset" } }]
  pumpSet;
  sharedPumpsetId;
  showPumpList=true;

  constructor(
    private loginService: LoginService,
    private listLoader: ListLoaderService,
    public appEventService: AppEventService,
    private restDataService: RestDataService,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.sharedPumpsetId=params['share'];   
      
    });
    this.appEventService.events.subscribe(event => {
      if (event.name == "SELECTION") {
        this.showPumpList=false;
       }
      if (event.name == "CACHE_LOADED") {               
        this.cacheLoading = false;        
        if(!this.sharedPumpsetId){
          this.cacheLoadedAndNotSharing=true;
        } 
      }
    })
  }
  ngOnInit(): void {
  }

  setLoggedIn(loginState) {
    this.loggedIn = loginState == LoginState.LOGGEDIN;
    if (this.loggedIn) {
      this.loginService.startRefreshTokenCycle();
      this.listLoader.loadLists();
    }
  }

  changePumpSet(pumpSet) {
    this.pumpSet = pumpSet;
  }
}
